import PageHeader from "app/shared/PageHeader";
import "./ReportView.scss";
import { Button, Radio, Tag } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import TableViewManager from "app/shared/TableViewManager";
import { AgTableServer } from "app/shared/AgTable";
import { useLocation, useParams } from "react-router-dom";
import { apiGet, apiPost } from "app/services/apiServices";
import {
  API_ENDPOINT_FETCH_DB_TABLE_PREVIEW,
  API_ENDPOINT_FETCH_REPORT_TABLE_SCHEMA,
  API_ENDPOINT_FETCH_DB_TABLE_PREVIEW_PG
} from "app/scenes/FinkAnalytics/finkanalytics.constants";
import {
  getColumnDefinationFromTable,
  processZARowForColumnDefs,
} from "app/scenes/FinkAnalytics/fa.helper";
import Loader from "app/shared/Loader";
import TableViewManagerV2 from "app/shared/TableViewManagerV2";
import { useRecoilState } from "recoil";
import { currentPDFData, userInfo } from "app/config/States/users";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { indexOf } from "lodash";
import {
  API_ENDPOINT_AG_TABLE_LIST_ALL_VIEW,
  API_ENDPOINT_AG_TABLE_LIST_ALL_VIEW_OPEN,
} from "app/shared/AgTable/AgTable.constants";
import { getProcessedDefinition } from "app/utils/generic.helper";

export default function ReportView(props: any) {
  const [selectedSheet, setSelectedSheet] = useState("DATA");
  const [isLoading, setLoading] = useState(true);
  const [colDefs, setColDefs] = useState<any[]>([]);
  const [selectedView, setSelectedView] = useState<any[]>([]);
  const [userDetails, setUserDetails] = useRecoilState<any>(userInfo);
  const [currentSheetIndex, setCurrentSheetIndex] = useState();
  const location = useLocation();
  const gridRef: any = useRef();
  const gridRefArray: any = useRef([]);
  const [recoilPDFData, setRecoilPdfData] =
    useRecoilState<string>(currentPDFData);
  const { dbType, database, table, selectedWorkspaceId,db } = location.state;
  console.log(selectedWorkspaceId, "selectedWorkspaceId check");
  console.log("location check", location);
  const { reportId } = useParams();

  useEffect(() => {
    fetchTotalReportViews();
  }, []);


  useEffect(() => {
    if (selectedSheet && selectedSheet !== "DATA") {
      const index = currentSheetIndex || 0;
      gridRefArray.current[index]?.loadGridView(selectedSheet,"REPORT_MANAGER");
    }
  }, [selectedSheet]);

  const fetchTotalReportViews = async () => {
    setLoading(true);

    const response = await apiPost(API_ENDPOINT_AG_TABLE_LIST_ALL_VIEW_OPEN, {
      moduleId: "REPORT_MANAGER",
      reportId: reportId,
    });
    if (response.data) {
      setSelectedView(response.data);
      fetchReportViewSchema();
    }
  };

  // const fetchReportViewSchema = async () => {
  //   console.log(reportId, "reportId check");
  //   const response = await apiPost(
  //     API_ENDPOINT_FETCH_REPORT_TABLE_SCHEMA + reportId,
  //     {
  //       workspace_id: selectedWorkspaceId,
  //     }
  //   );
  // console.log(response.data, "response in fetchReportViewSchema");

  //   setColDefs(response?.data?.state?.columnDefs);
  //   setLoading(false);
  // };
  const fetchReportViewSchema = async () => {
    console.log(reportId, "reportId check");
    console.log(selectedWorkspaceId, "workspaceId check");
  
    if (!reportId || !selectedWorkspaceId) return;
  
    try {
      const response = await apiPost(
        API_ENDPOINT_FETCH_REPORT_TABLE_SCHEMA + reportId,
        { workspace_id: selectedWorkspaceId }
      );
  
      console.log("Schema response:", response.data);
      console.log("Column definitions from schema:", response?.data?.state?.columnDefs);
  
      const columnDefs = response?.data?.state?.columnDefs || [];
      
      // If columnDefs is empty, try to fetch a sample row to generate column definitions
      if (columnDefs.length === 0 && dbType === "mongodb") {
        console.warn("No column definitions found, attempting to fetch sample data to generate columns...");
        try {
          const previewEndpoint = dbType === "mongodb"
            ? API_ENDPOINT_FETCH_DB_TABLE_PREVIEW
            : API_ENDPOINT_FETCH_DB_TABLE_PREVIEW_PG;
          const sampleResponse = await apiPost(previewEndpoint, {
            startRow: 0,
            endRow: 1,
            rowGroupCols: [],
            valueCols: [],
            pivotCols: [],
            pivotMode: false,
            groupKeys: [],
            filterModel: {},
            sortModel: [],
            database: database,
            dbType: dbType,
            table: table,
          });
          
          console.log("Sample data response:", sampleResponse);
          
          if (sampleResponse?.data?.rows && sampleResponse.data.rows.length > 0) {
            const firstRow = sampleResponse.data.rows[0];
            const autoGeneratedColDefs = Object.keys(firstRow).map((key) => {
              const value = firstRow[key];
              const valueType = typeof value;
              const isObject = valueType === "object" && value !== null && !Array.isArray(value);
              
              return {
                field: key,
                headerName: key,
                filter: valueType === "number" ? "agNumberColumnFilter" : "agTextColumnFilter",
                enableValue: valueType === "number",
                enableRowGroup: valueType !== "number",
                // Add cell renderer for objects to convert them to JSON strings
                ...(isObject ? {
                  valueGetter: (params: any) => {
                    const cellValue = params.data?.[key];
                    if (cellValue && typeof cellValue === "object" && !Array.isArray(cellValue)) {
                      return JSON.stringify(cellValue);
                    }
                    return cellValue;
                  },
                  cellRenderer: (params: any) => {
                    const cellValue = params.value;
                    if (cellValue && typeof cellValue === "object" && !Array.isArray(cellValue)) {
                      return JSON.stringify(cellValue);
                    }
                    return cellValue != null ? String(cellValue) : "-";
                  }
                } : {})
              };
            });
            console.log("Auto-generated column definitions:", autoGeneratedColDefs);
            setColDefs(autoGeneratedColDefs);
          } else {
            console.warn("No sample data returned from API");
            setColDefs([]);
          }
        } catch (sampleError) {
          console.error("Error fetching sample data:", sampleError);
          setColDefs([]);
        }
      } else {
        setColDefs(columnDefs);
      }
    } catch (error) {
      console.error("Error fetching schema:", error);
      setColDefs([]);
    } finally {
      setLoading(false);
    }
  };
  

  const handleExportAllToExcel = async () => {
    const workbook = new ExcelJS.Workbook();

    let spreadsheets = [];

    let mainDataSheet =
      gridRef.current && gridRef.current.exportExcelDataRaw("Main Data");
    spreadsheets.push(mainDataSheet);

    for (let index = 0; index < gridRefArray.current.length; index++) {
      const singleGridRef = gridRefArray.current[index];

      if (singleGridRef && singleGridRef.exportExcelDataRaw) {
        let rawSheetData = singleGridRef.exportExcelDataRaw(
          selectedView[index]?.name || "Sheet"
        );

        spreadsheets.push(rawSheetData);
      } else {
      }
    }
    gridRef.current &&
      gridRef.current.exportMultipleSheetAsNewExcel(
        spreadsheets,
        "Finkraft_Report"
      );
  };

  const handleSelectView = (viewId: any) => {
    setSelectedView(viewId);
    setSelectedSheet(viewId[viewId.length - 1]);
  };

  const handleSaveView = (
    viewId: string,
    moduleId: string,
    viewName: string
  ) => {
    gridRef.current && gridRef.current.updateGridView(viewId, "REPORT_MANAGER");
    setSelectedView([...selectedView, { name: viewName, _id: viewId }]);
  };

  const getProcessedDefinitions = (columnDefination: any) => {
    let finalDefs = getProcessedDefinition(
      columnDefination,
      "SERVER",
      setRecoilPdfData
    );
    return finalDefs;
  };
  const endpoint: string =
  dbType === "mongodb"
    ? API_ENDPOINT_FETCH_DB_TABLE_PREVIEW
    : API_ENDPOINT_FETCH_DB_TABLE_PREVIEW_PG;
    // : "http://192.168.0.159:7002/api/finalytics/tables/data/previewpg"


    console.log("colDefs check:", colDefs);
    console.log("colDefs length:", colDefs?.length);
    console.log("dbType:", dbType);
    console.log("endpoint:", endpoint);

  return (
    <div className="ReportView">
      <div className="HeaderContainer">
        <PageHeader
          goBack
          title="Report Manager"
          rightActions={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                size="small"
                type="primary"
                onClick={handleExportAllToExcel}
                style={{ marginRight: 24 }}
              >
                Download Report
              </Button>
            </div>
          }
        />
      </div>
      {isLoading ? (
        <div style={{ height: "100%" }}>
          <Loader />
        </div>
      ) : (
        <>
          <div className="MainContent">
            <div
              className={
                "ViewContainer " +
                (selectedSheet === "DATA" ? " " : " hiddenTable")
              }
            >
              <AgTableServer
                //@ts-ignore
                columnDefs={getProcessedDefinitions(colDefs)}
                endpoint={endpoint}
                // endpoint={"http://192.168.1.59:7001/api/recon/hotel"}
                pdfDataKey="asset_link"
                ref={gridRef}
                serverPayload={{
                  database: database,
                  dbType: dbType,
                  table: table,
                }}
                enablePDFViewer
                pdfV2
                generateColumn={colDefs.length === 0}
                currentWorkspaceId={selectedWorkspaceId}
                TableViewPayload={{
                  workspace_id: selectedWorkspaceId,
                  workspace_name: userDetails?.currentWorkspace?.name,
                  viewType: "REPORT_MANAGER",
                  reportId: reportId,
                }}
              />
            </div>
            {(selectedView || []).map((item: any, index: any) => {
              return (
                <div
                  className={
                    "ViewContainer " +
                    (selectedSheet === item?._id ? " " : " hiddenTable")
                  }
                  key={index}
                >
                  <AgTableServer
                    key={index}
                    //@ts-ignore
                    columnDefs={getProcessedDefinitions(colDefs)}
                    endpoint={endpoint}
                    // endpoint={"http://192.168.1.59:7001/api/recon/hotel"}
                    pdfDataKey="Invoice_link"
                    ref={(el) => (gridRefArray.current[index] = el)}
                    serverPayload={{
                      database: database,
                      dbType: dbType,
                      table: table,
                      defaultView: item?._id || "test",
                      selectedSheet
                    }}
                    moduleId="REPORT_MANAGER"
                    defaultView={item?._id}
                    generateColumn={colDefs.length === 0}
                    currentWorkspaceId={selectedView[index]?.workspace_id || selectedWorkspaceId}
                    TableViewPayload={{
                      workspace_id: selectedWorkspaceId,
                      workspace_name: userDetails?.currentWorkspace?.name,
                      viewType: "REPORT_MANAGER",
                      reportId: reportId,
                    }}
                  />
                </div>
              );
            })}
          </div>

          <div className="SheetsContainer">
            <Button
              size="small"
              type={selectedSheet === "DATA" ? "primary" : "default"}
              icon={<MenuOutlined />}
              onClick={() => setSelectedSheet("DATA")}
            >
              Data Sheet
            </Button>

            {selectedView.map((item: any, index: any) => {
              return (
                <Button
                  size="small"
                  style={{ marginLeft: 12 }}
                  icon={<MenuOutlined />}
                  onClick={() => {
                    console.log("selected view ---", item);
                    setSelectedSheet(item?._id);
                    setCurrentSheetIndex(index);
                  }}
                  type={selectedSheet === item._id ? "primary" : "default"}
                >
                  {item?.name}
                </Button>
              );
            })}
            <div style={{ marginLeft: 12 }}>
              <TableViewManagerV2
                selectedSheet={selectedSheet}
                moduleId={"REPORT_MANAGER"}
                reportId={reportId}
                selectView={(viewId: string) => handleSelectView(viewId)}
                updateView={handleSaveView}
                updateViewNew={(viewId: string) =>
                  gridRefArray.current &&
                  gridRefArray.current?.[currentSheetIndex || 0].updateGridView(
                    selectedSheet,
                    "REPORT_MANAGER"
                  )
                }
                viewMode={props.viewMode}
                workspace_id={selectedWorkspaceId}
                workspace_name={userDetails?.currentWorkspace?.name}
                getGridState={() => gridRef.current?.getGridState()}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}





